import _ from 'lodash'

import type { AbTestsParametersBidderValuesDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'
import type { AbTestOption, Bidders } from 'features/ab-tests/types/abTestParametersSchema'

export const biddersFromDTO = (items: AbTestsParametersBidderValuesDTO[]): Bidders =>
  _.chain(items)
    .keyBy('id')
    .mapValues(
      ({ label }: AbTestsParametersBidderValuesDTO): AbTestOption => ({
        label,
      }),
    )
    .value()
